import React from 'react'
import ErrorMessage from 'components/share/ErrorMessage'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import InsightViewOption from 'enums/InsightViewOption'

import { SummaryMetricsType } from '../../types'
import { VocMessageContent } from '../ErrorMessage'

const VocComingSoonGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetSetting = useDashboardWidgetSetting<SummaryMetricsType>(widgetId)

  const { viewOption } = widgetSetting
  if ([InsightViewOption.STAR_RATINGS, InsightViewOption.SURVEY_SCORES].includes(viewOption!)) {
    return (
      <ErrorMessage>
        <VocMessageContent />
      </ErrorMessage>
    )
  }
  return children
}

export default VocComingSoonGuard
